/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Add_Image_BtnInputs */

const vi_product_add_image_btn = /** @type {(inputs: Product_Add_Image_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm ảnh`)
};

/**

* @param {Product_Add_Image_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_add_image_btn = /** @type {((inputs?: Product_Add_Image_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Add_Image_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_add_image_btn(inputs)
});